import { Table } from "antd";
import { ConnectedProps } from "react-redux";
import { useEffect } from "react";

import { insuranceOfferRequestsColumns } from "../../../utils";
import InsuranceHomeHeader from "../Header";
import connector from "./Container";

const InsuranceOfferRequests = ({
  state,
  actions,
}: ConnectedProps<typeof connector>) => {
  const { offerRequests } = state;

  useEffect(() => {
    actions.getInsuranceOfferRequests();
  }, []);
  return (
    <div className="bg-white">
      <InsuranceHomeHeader />
      <div className="px-8 py-4">
        <Table
          columns={insuranceOfferRequestsColumns()}
          dataSource={offerRequests}
        />
      </div>
    </div>
  );
};

export default InsuranceOfferRequests;
